import "./MenuButton.css";

function MenuButton({ variant, text, icon, onClick, style }) {
  if (variant == "icon") {
    return (
      <div className="iconOnly" onClick={() => onClick()}>
        {icon}
      </div>
    );
  }
  return (
    <div
      className="MenuButtonContainer"
      onClick={() => onClick()}
      style={style}
    >
      <div className="MenuButtonText">{text}</div>
      <div className="MenuButtonEnd">{icon}</div>
    </div>
  );
}
export default MenuButton;
